import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const DecreaseOutboundLinkCountView = ({
  auditResult
}) => {
  const {
    status,
    linksCount,
    maxLinksCount
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.DECREASE_OUTBOUND_LINK_COUNT",
      options: {
        maxLinksCount
      }
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.DECREASE_OUTBOUND_LINK_COUNT",
      options: {
        linksCount,
        maxLinksCount
      }
    }),
    status: status
  });
};